import { useLocation, useNavigate } from "react-router-dom";
import { Tabs, Tab, Box, Badge } from "@mui/material";
import { type FC, useEffect } from "react";
import { useTypedSelector } from "../../redux/store";
import { useDispatch } from "react-redux";
import { setUnseenChats } from "../../redux/slices/globalChat";

export const ADMIN_AUTH_ID = "AdminAuthId";
export const ADMIN_AUTH_ID1 = "AdminAuthId1";
const ADMIN_AUTH_IDS = [ADMIN_AUTH_ID, ADMIN_AUTH_ID1];

export const HeaderTabs: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const unseenChats = useTypedSelector((state) => state.globalChat.unseenChats);
  const selectedTab = location.pathname.includes("/admin")
    ? 2
    : location.pathname.includes("/chat")
    ? 1
    : 0;
  const currentUser = useTypedSelector((state) => state.auth.currentUser);

  const isAdmin = ADMIN_AUTH_IDS.includes(currentUser?.auth0Id ?? "");

  useEffect(() => {
    if (selectedTab === 1) {
      dispatch(setUnseenChats(0));
    }
  }, [selectedTab, dispatch, unseenChats]);

  return (
    <Box sx={{ bgcolor: "black", position: "relative" }}>
      <Tabs value={selectedTab} centered textColor="inherit">
        <Tab
          label="Playlist"
          onClick={() => {
            navigate("/vote");
          }}
          sx={{ color: "white" }}
        />
        <Tab
          label={
            <Badge badgeContent={unseenChats || undefined} color="error">
              Chat
            </Badge>
          }
          onClick={() => {
            navigate("/chat");
          }}
          sx={{ color: "white" }}
        />

        {isAdmin && (
          <Tab
            label="Dashboard"
            onClick={() => {
              navigate("/admin");
            }}
            sx={{ color: "white" }}
          />
        )}
      </Tabs>
    </Box>
  );
};
